/**
 * To see the data collected in quality-forms:
 *
 * - Open New Relic
 * - Search for Quality Forms UI and open it
 * - Open Events Explorer (You should be able to find this in "More views" section)
 * - Select Page Action as Event Type
 * - Select an attribute of your choice in Dimensions and/or edit a query (NRQL) as necessary
 *
 * To see what kind of PageActions and Custom Attributes are added,
 * please go to src/services/newRelic/NewRelicEnum.ts.
 */

/**
 * These functions (addPageAction and setCustomAttribute) are based on this file:
 * https://bitbucket.org/inindca/architect/src/2ed02c31831e7ecf2d5d43059cac7be525a7015a/src/services/basic/newRelicService.es6.js?at=master#lines-21:29
 */

const newRelicService = {
    addPageAction: (...args) => {
        try {
            window?.newrelic?.addPageAction?.(...args);
        } catch (error) {
            console.error(error);
        }
    },
    setCustomAttribute: (...args) => {
        try {
            window?.newrelic?.setCustomAttribute?.(...args);
        } catch (error) {
            console.error(error);
        }
    },
};

export default newRelicService;
